import { ItemsComponent } from './Items.Component';
export default ItemsComponent;